module.exports = __webpack_public_path__ + "img/borderWaves.af8ef113.svg";